module.exports = __webpack_public_path__ + "static/sponsorship_img-05-c-49e00f0d83cc839d904b6fe5421a9be1.jpg";